import React, { useState } from "react";
import carsouleimg1 from "../../assets/Landing/carsouleimg1.png";
import carsouleimg2 from "../../assets/Landing/carsouleimg2.png";
import carsouleimg3 from "../../assets/Landing/carsouleimg3.png";
import abc from "../../assets/Landing/abc.png";
import mediaimg1 from "../../assets/Landing/mediaimg1.png";
import mediaimg2 from "../../assets/Landing/mediaimg2.png";
import mediaimg3 from "../../assets/Landing/mediaimg3.png";

const Carsoule = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const data = [
    {
      title: "Manufacturers",
      description:
        "Assist other business owners in achieving their production goals by offering your superior manufacturing capabilities. Provide white or private labeling services to create an additional revenue stream for your business. Sell directly to buyers who need your products.",
      imgSrc: mediaimg1,
    },
    {
      title: "Suppliers",
      description:
        "Support fellow businesses in achieving their production goals by offering exceptional supply capabilities.",
      imgSrc: mediaimg2,
    },
    {
      title: "Wholesalers",
      description:
        "Utilize our SME network by selling on our platform. Reach millions of active buyers who are seeking a reliable business partner to grow with.",
      imgSrc: mediaimg3,
    },
  ];

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % data.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? data.length - 1 : prevIndex - 1
    );
  };

  const images = [
    { src: carsouleimg1, name: "ABC Manufactures Pvt. Ltd." },
    { src: carsouleimg2, name: "ABC Manufactures Pvt. Ltd." },
    { src: carsouleimg3, name: "ABC Manufactures Pvt. Ltd." },
  ];

  return (
    <>
      <div className="w-full h-[1500px]">
        <div className=" h-[50px] m-auto flex items-center justify-center">
          <p className="w-[466px] h-[30px] font-semibold text-[20px] text-[#FF6300] mt-10">
            Unleash Infinite Business Opportunities Today
          </p>
        </div>
        <div className="w-[1440px] h-[368px] bg-white rounded-md shadow-md m-auto mt-10">
          <div className="w-[1440px] h-[80px] flex items-center justify-center">
            <p className="w-[477px] h-[48px] text-[16px] font-normal">
              <span className="text-[#FF6300] text-[20px] font-semibold">
                {" "}
                5,000 +{" "}
              </span>
              sellers trust Naayatrade for their online business.
            </p>
          </div>
          <div className="flex justify-center gap-8">
            {images.map((image, index) => (
              <div key={index} className="flex flex-col items-center">
                <img src={image.src} alt={`Brand ${index + 1}`} />
                <div className="flex items-center gap-2 mt-4">
                  <img src={abc} alt="abc" />
                  <p className="w-[230px] h-[27px] font-semibold text-[16px] p-1">
                    {image.name}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="w-[1440px] h-[70px] flex justify-center items-center ">
            <p className="w-[100px] h-[17px] text-[14px] text-[#FF6300]">
              See All Stories
            </p>
          </div>
        </div>

        {/* second section carousel */}
        <div className="w-[1440px h-[100px] flex justify-center items-center">
          <p className="w-[291px] h-[30px] font-semibold text-[#FF6300] text-[20px]">
            Grow your business with us!!
          </p>
        </div>

        <div className="w-[1440px] h-[280px] bg-white rounded-md shadow-md m-auto relative">
          <div className="w-[1440px] h-[260px] flex justify-center items-center gap-10">
            {/* Left side content */}
            <div>
              <p className="w-[136px] h-[38px] text-[#FF6300] font-semibold text-[18px]">
                {data[currentIndex].title}
              </p>
              <p className="w-[564px] h-[120px] font-normal text-[16px]">
                {data[currentIndex].description}
              </p>
            </div>
            {/* Right side image */}
            <div>
              <img
                src={data[currentIndex].imgSrc}
                alt=""
                className="w-[442px] h-[216px] mt-6 ml-7"
              />
            </div>
          </div>

          {/* Previous Button */}
          <button
            onClick={prevSlide}
            className="absolute left-20 top-1/2 transform -translate-y-1/2 bg-gray-200 rounded-full w-10 h-10 flex items-center justify-center hover:bg-red-500"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-gray-500 hover:text-white"
            >
              <path
                d="M15 19L8 12L15 5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>

          {/* Next Button */}
          <button
            onClick={nextSlide}
            className="absolute right-20 top-1/2 transform -translate-y-1/2 bg-gray-200 rounded-full w-10 h-10 flex items-center justify-center hover:bg-red-500"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-gray-500 hover:text-white"
            >
              <path
                d="M9 19L16 12L9 5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        {/* third section form */}

        <div className="w-[1240px] h-[840px] m-auto relative">
          <div
            className="w-[1009px] h-[746px] m-auto top-[-30px] right-[-220px] relative bg-[#FEF3DE] 
    rounded-tr-[142px] rounded-bl-[142px] mt-40"
          >
            <div className="w-[1009px] h-[170px]  flex justify-center items-center ">
              <p className="w-[273px] h-[40px] font-semibold text-[20px]">We are happy to help you</p>
            </div>
            <div className="w-full max-w-lg m-auto ">
  <form className="space-y-6">
    <div>
      <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="name">
        Name
      </label>
      <input
        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
        type="text"
        id="name"
        name="name"
        placeholder="Enter your name"
        required
      />
    </div>
    <div>
      <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
        Email
      </label>
      <input
        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
        type="email"
        id="email"
        name="email"
        placeholder="Enter your email"
        required
      />
    </div>
    <div>
      <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="business">
        Business
      </label>
      <input
        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
        type="text"
        id="business"
        name="business"
        placeholder="Enter your business name"
        required
      />
    </div>
    <div>
      <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="inquiry">
        Inquiry
      </label>
      <textarea
        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
        id="inquiry"
        name="inquiry"
        placeholder="Enter your inquiry"
        rows="4"
        required
      ></textarea>
    </div>
    <div className="w-[400pxpx] h-[50px] flex items-center justify-center">
      <button
        className="w-[147px] h-[42px] items-center  bg-orange-500 text-white py-2 px-4 rounded-md hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-opacity-50"
        type="submit"
      >
        Submit
      </button>
    </div> 
  </form>
</div>

            <div
              className="w-[484px] h-[616px] bg-[#FF8100] rounded-tr-[142px] rounded-bl-[142px] 
      absolute top-[80px] left-[-340px] p-6"
            >
              <p className="w-[180px] h-[37px] text-white font-semibold text-[18px]">
                Get started Now
              </p>
              <p className="w-[430px] h-[130px] text-white font-normal text-[16px]">
                Schedule a call or submit a form to book a consulation to sell
                on NAAYATRADE. Selling products is easier now
              </p>
              <div className=" w-[402px] h-[60px] text-white font-semibold text-[18px]">
                <p className=" h-[50px] font-semibold pb-2 ">
                  What makes a quality product listing page:
                </p>
                <ul className="list-disc list-item ml-5 w-[210px] h-[40px]">
                  <li className="  text-[16px] font-normal">
                    Unique Product Names
                  </li>
                </ul>
                <ul className="list-disc list-item ml-5 w-[210px] h-[40px]">
                  <li className="text-[16px] font-normal">HD Product Images</li>
                </ul>
                <ul className="list-disc list-item ml-5 w-[210px] h-[40px]">
                  <li className="text-[16px] font-normal">
                    Product Attributes
                  </li>
                </ul>
                <ul className="list-disc list-item ml-5 w-[210px] h-[40px]">
                  <li className="text-[16px] font-normal">
                    Product Descriptions{" "}
                  </li>
                </ul>
                <ul className="list-disc list-item ml-5 w-[210px] h-[40px]">
                  <li className="text-[16px] font-normal">
                  Product Specifications
                  </li>
                </ul>
                <ul className="list-disc list-item ml-5 w-[210px] h-[40px]">
                  <li className="text-[16px] font-normal">
                  Product Features

                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Carsoule;
